import Faltantes from "./Faltantes";
export default Faltantes;